export const MAX_NUMBER_OF_TAKEN_PHOTOS = 3;
export const HEIGHT_OF_NAVIGATION_HEADER = 50;
export const INVALID_INFO_REPORT_LINK = 'https://docs.google.com/forms/d/e/1FAIpQLSfObUfjutX8WNPPUqtDQZ30f6GCYP4FRHgjehG69sdoQci5AQ/viewform';
